import Reveal from "@/components/feature/Reveal";
import SectionHeading from "@/components/feature/SectionHeading";
import { minorConsentNotes } from "@/mocks/legalPages";

/** 未成年の方へ｜ご来院前にご確認ください（注意事項）。 */
export default function NotesList() {
  return (
    <section className="bg-background-100 py-20 md:py-28 lg:py-32">
      <div className="u-container">
        <div className="mx-auto max-w-3xl">
          <Reveal>
            <SectionHeading en="NOTES" jp="ご来院前にご確認ください" />
          </Reveal>

          <Reveal delay={100}>
            <ul className="mt-10 flex flex-col border-t border-foreground-950/12">
              {minorConsentNotes.map((note, index) => (
                <li
                  key={index}
                  className="flex items-start gap-4 border-b border-foreground-950/12 py-6"
                >
                  <i className="ri-checkbox-blank-circle-line mt-1 text-[6px] text-accent-600" aria-hidden />
                  <p className="text-[13px] leading-[2.1] text-foreground-700 md:text-sm">{note}</p>
                </li>
              ))}
            </ul>
          </Reveal>
        </div>
      </div>
    </section>
  );
}